define('app/config/states',{
	US: [{
			value: 'AL',
			label: 'Alabama'
		},
		{
			value: 'AK',
			label: 'Alaska'
		},
		{
			value: 'AZ',
			label: 'Arizona'
		},
		{
			value: 'AR',
			label: 'Arkansas'
		},
		{
			value: 'CA',
			label: 'California'
		},
		{
			value: 'CO',
			label: 'Colorado'
		},
		{
			value: 'CT',
			label: 'Connecticut'
		},
		{
			value: 'DE',
			label: 'Delaware'
		},
		{
			value: 'DC',
			label: 'District of Columbia'
		},
		{
			value: 'FL',
			label: 'Florida'
		},
		{
			value: 'GA',
			label: 'Georgia'
		},
		{
			value: 'GU',
			label: 'Guam'
		},
		{
			value: 'HI',
			label: 'Hawaii'
		},
		{
			value: 'ID',
			label: 'Idaho'
		},
		{
			value: 'IL',
			label: 'Illinois'
		},
		{
			value: 'IN',
			label: 'Indiana'
		},
		{
			value: 'IA',
			label: 'Iowa'
		},
		{
			value: 'KS',
			label: 'Kansas'
		},
		{
			value: 'KY',
			label: 'Kentucky'
		},
		{
			value: 'LA',
			label: 'Louisiana'
		},
		{
			value: 'ME',
			label: 'Maine'
		},
		{
			value: 'MD',
			label: 'Maryland'
		},
		{
			value: 'MA',
			label: 'Massachusetts'
		},
		{
			value: 'MI',
			label: 'Michigan'
		},
		{
			value: 'MN',
			label: 'Minnesota'
		},
		{
			value: 'MS',
			label: 'Mississippi'
		},
		{
			value: 'MO',
			label: 'Missouri'
		},
		{
			value: 'MT',
			label: 'Montana'
		},
		{
			value: 'NE',
			label: 'Nebraska'
		},
		{
			value: 'NV',
			label: 'Nevada'
		},
		{
			value: 'NH',
			label: 'New Hampshire'
		},
		{
			value: 'NJ',
			label: 'New Jersey'
		},
		{
			value: 'NM',
			label: 'New Mexico'
		},
		{
			value: 'NY',
			label: 'New York'
		},
		{
			value: 'NC',
			label: 'North Carolina'
		},
		{
			value: 'ND',
			label: 'North Dakota'
		},
		{
			value: 'OH',
			label: 'Ohio'
		},
		{
			value: 'OK',
			label: 'Oklahoma'
		},
		{
			value: 'OR',
			label: 'Oregon'
		},
		{
			value: 'PA',
			label: 'Pennsylvania'
		},
		{
			value: 'PR',
			label: 'Puerto Rico'
		},
		{
			value: 'RI',
			label: 'Rhode Island'
		},
		{
			value: 'SC',
			label: 'South Carolina'
		},
		{
			value: 'SD',
			label: 'South Dakota'
		},
		{
			value: 'TN',
			label: 'Tennessee'
		},
		{
			value: 'TX',
			label: 'Texas'
		},
		{
			value: 'UT',
			label: 'Utah'
		},
		{
			value: 'VT',
			label: 'Vermont'
		},
		{
			value: 'VI',
			label: 'Virgin Islands'
		},
		{
			value: 'VA',
			label: 'Virginia'
		},
		{
			value: 'WA',
			label: 'Washington'
		},
		{
			value: 'WV',
			label: 'West Virginia'
		},
		{
			value: 'WI',
			label: 'Wisconsin'
		},
		{
			value: 'WY',
			label: 'Wyoming'
		}
	],
	FDIC_BOSTON: [{
			value: 'CT',
			label: 'Connecticut'
		},
		{
			value: 'ME',
			label: 'Maine'
		},
		{
			value: 'MA',
			label: 'Massachusetts'
		},
		{
			value: 'NH',
			label: 'New Hampshire'
		},
		{
			value: 'RI',
			label: 'Rhode Island'
		},
		{
			value: 'VT',
			label: 'Vermont'
		}
	],
	FDIC_NEWYORK: [{
		value: 'NY',
		label: 'New York'
	}],
	FDIC_PHILADELPHIA: [{
			value: 'NJ',
			label: 'New Jersey'
		},
		{
			value: 'PA',
			label: 'Pennsylvania'
		}
	],
	FDIC_CLEVELAND: [{
			value: 'KY',
			label: 'Kentucky'
		},
		{
			value: 'OH',
			label: 'Ohio'
		},
		{
			value: 'PA',
			label: 'Pennsylvania'
		}
	],
	FDIC_RICHMOND: [{
			value: 'DE',
			label: 'Delaware'
		},
		{
			value: 'DC',
			label: 'District of Columbia'
		},
		{
			value: 'KY',
			label: 'Kentucky'
		},
		{
			value: 'MD',
			label: 'Maryland'
		},
		{
			value: 'NC',
			label: 'North Carolina'
		},
		{
			value: 'SC',
			label: 'South Carolina'
		},
		{
			value: 'VA',
			label: 'Virginia'
		},
		{
			value: 'WV',
			label: 'West Virginia'
		}
	],
	FDIC_ATLANTA: [{
			value: 'AL',
			label: 'Alabama'
		},
		{
			value: 'FL',
			label: 'Florida'
		},
		{
			value: 'GA',
			label: 'Georgia'
		},
		{
			value: 'LA',
			label: 'Louisiana'
		},
		{
			value: 'MS',
			label: 'Mississippi'
		},
		{
			value: 'TN',
			label: 'Tennessee'
		}
	],
	FDIC_CHICAGO: [{
			value: 'MI',
			label: 'Michigan'
		},
		{
			value: 'IL',
			label: 'Illinois'
		},
		{
			value: 'IN',
			label: 'Indiana'
		},
		{
			value: 'IA',
			label: 'Iowa'
		},
		{
			value: 'WI',
			label: 'Wisconsin'
		}
	],
	FDIC_STLOUIS: [{
			value: 'AR',
			label: 'Arkansas'
		},
		{
			value: 'IL',
			label: 'Illinois'
		},
		{
			value: 'IN',
			label: 'Indiana'
		},
		{
			value: 'KY',
			label: 'Kentucky'
		},
		{
			value: 'MS',
			label: 'Mississippi'
		},
		{
			value: 'MO',
			label: 'Missouri'
		},
		{
			value: 'TN',
			label: 'Tennessee'
		}
	],
	FDIC_MINNEAPOLIS: [{
			value: 'MI',
			label: 'Michigan'
		},
		{
			value: 'MN',
			label: 'Minnesota'
		},
		{
			value: 'MT',
			label: 'Montana'
		},
		{
			value: 'NE',
			label: 'Nebraska'
		},
		{
			value: 'ND',
			label: 'North Dakota'
		},
		{
			value: 'SD',
			label: 'South Dakota'
		},
		{
			value: 'WI',
			label: 'Wisconsin'
		}
	],
	FDIC_KANSAS_CITY: [{
			value: 'CO',
			label: 'Colorado'
		},
		{
			value: 'KS',
			label: 'Kansas'
		},
		{
			value: 'MO',
			label: 'Missouri'
		},
		{
			value: 'NE',
			label: 'Nebraska'
		},
		{
			value: 'NM',
			label: 'New Mexico'
		},
		{
			value: 'OK',
			label: 'Oklahoma'
		},
		{
			value: 'WY',
			label: 'Wyoming'
		}
	],
	FDIC_DALLAS: [{
			value: 'LA',
			label: 'Louisiana'
		},
		{
			value: 'NM',
			label: 'New Mexico'
		},
		{
			value: 'TX',
			label: 'Texas'
		}
	],
	FDIC_SANFRANCSCO: [{
			value: 'AK',
			label: 'Alaska'
		},
		{
			value: 'AZ',
			label: 'Arizona'
		},
		{
			value: 'CA',
			label: 'California'
		},
		{
			value: 'HI',
			label: 'Hawaii'
		},
		{
			value: 'ID',
			label: 'Idaho'
		},
		{
			value: 'NV',
			label: 'Nevada'
		},
		{
			value: 'OR',
			label: 'Oregon'
		},
		{
			value: 'UT',
			label: 'Utah'
		},
		{
			value: 'WA',
			label: 'Washington'
		}
	],
	NCUA_EASTERN: [{
			value: 'CT',
			label: 'Connecticut'
		},
		{
			value: 'DE',
			label: 'Delaware'
		},
		{
			value: 'DC',
			label: 'District of Columbia'
		},
		{
			value: 'ME',
			label: 'Maine'
		},
		{
			value: 'MD',
			label: 'Maryland'
		},
		{
			value: 'MA',
			label: 'Massachusetts'
		},
		{
			value: 'MI',
			label: 'Michigan'
		},
		{
			value: 'NH',
			label: 'New Hampshire'
		},
		{
			value: 'NJ',
			label: 'New Jersey'
		},
		{
			value: 'NY',
			label: 'New York'
		},
		{
			value: 'OH',
			label: 'Ohio'
		},
		{
			value: 'PA',
			label: 'Pennsylvania'
		},
		{
			value: 'RI',
			label: 'Rhode Island'
		},
		{
			value: 'VT',
			label: 'Vermont'
		},
		{
			value: 'VA',
			label: 'Virginia'
		},
		{
			value: 'WV',
			label: 'West Virginia'
		}
	],
	NCUA_SOUTHERN: [{
			value: 'AL',
			label: 'Alabama'
		},
		{
			value: 'AR',
			label: 'Arkansas'
		},
		{
			value: 'FL',
			label: 'Florida'
		},
		{
			value: 'GA',
			label: 'Georgia'
		},
		{
			value: 'IN',
			label: 'Indiana'
		},
		{
			value: 'KY',
			label: 'Kentucky'
		},
		{
			value: 'LA',
			label: 'Louisiana'
		},
		{
			value: 'MS',
			label: 'Mississippi'
		},
		{
			value: 'NC',
			label: 'North Carolina'
		},
		{
			value: 'OK',
			label: 'Oklahoma'
		},
		{
			value: 'PR',
			label: 'Puerto Rico'
		},
		{
			value: 'SC',
			label: 'South Carolina'
		},
		{
			value: 'TN',
			label: 'Tennessee'
		},
		{
			value: 'TX',
			label: 'Texas'
		},
		{
			value: 'VI',
			label: 'Virgin Islands'
		}
	],
	NCUA_WESTERN: [{
			value: 'AK',
			label: 'Alaska'
		},
		{
			value: 'AZ',
			label: 'Arizona'
		},
		{
			value: 'CA',
			label: 'California'
		},
		{
			value: 'CO',
			label: 'Colorado'
		},
		{
			value: 'GU',
			label: 'Guam'
		},
		{
			value: 'HI',
			label: 'Hawaii'
		},
		{
			value: 'ID',
			label: 'Idaho'
		},
		{
			value: 'IL',
			label: 'Illinois'
		},
		{
			value: 'IA',
			label: 'Iowa'
		},
		{
			value: 'KS',
			label: 'Kansas'
		},
		{
			value: 'MN',
			label: 'Minnesota'
		},
		{
			value: 'MO',
			label: 'Missouri'
		},
		{
			value: 'MT',
			label: 'Montana'
		},
		{
			value: 'NE',
			label: 'Nebraska'
		},
		{
			value: 'NV',
			label: 'Nevada'
		},
		{
			value: 'NM',
			label: 'New Mexico'
		},
		{
			value: 'ND',
			label: 'North Dakota'
		},
		{
			value: 'OR',
			label: 'Oregon'
		},
		{
			value: 'SD',
			label: 'South Dakota'
		},
		{
			value: 'UT',
			label: 'Utah'
		},
		{
			value: 'WA',
			label: 'Washington'
		},
		{
			value: 'WI',
			label: 'Wisconsin'
		},
		{
			value: 'WY',
			label: 'Wyoming'
		}
	]
});

